import { get_plan_excel_import_setting_by_flag } from 'liyu-pc-base/api/sys-model';

export default () => {
  const search_config: any = {
    model: {
      is_active: true,
      page_index: 1,
      pageSize: 2000,
    },
    watch: [],
  };
  return {
    getData: get_plan_excel_import_setting_by_flag,
    searchConfig: search_config,
  };
};
